import { Button, CellSimple, EllipsisText } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const CellSimpleEllipsizedSubtitleExample = {
  title: "CellSimple - Ellipsized subtitle",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [],

  Preview() {
    return (
      <CellSimple
        after={<Button key="icon" variant="secondary" size="small">Открыть</Button>}
        before={<PlaceholderIcon />}
        height="normal"
        subtitle={<EllipsisText>Чего не скажешь о длинной подписи, в этом примере она будет обрезан</EllipsisText>}
        title="Я — ячейка с очень длинным заголовком, но в этот раз текст не будет обрезан"
      />
    )
  },

  getCode() {
    return `<CellSimple
  after={<Button key="icon" variant="secondary" size="small">Открыть</Button>}
  before={<Icon24Placeholder />}
  height="normal"
  subtitle={<EllipsisText>Чего не скажешь о длинной подписи, в этом примере она будет обрезан</EllipsisText>}
  title="Я — ячейка с очень длинным заголовком, но в этот раз текст не будет обрезан"
/>`
  },
}